// The Tailwind fields' shared styles (BRK-S264): the same look as the MUI
// fields, on the type scale (docs/design-system.md). TextField, SelectField,
// PhoneField, SearchSelect, Typeahead, NumericField, AddressFieldset and
// ReadOnlyField read them, so a field can't drift from the rest.

/** A field's label: meta at 500, above the control. */
export const FIELD_LABEL = "text-meta font-medium text-brk-text";

/** The same label on a field carrying an error (BRK-S319): red with its
 *  border, so a missing answer reads as one at a glance, not only in the
 *  message under it. */
export const FIELD_LABEL_ERROR = "text-meta font-medium text-brk-danger";

/** The box a field draws around its value. */
const FIELD_BOX =
  "rounded-md border border-brk-border bg-brk-panel text-brk-text outline-none focus:border-brk-accent focus:ring-2 focus:ring-brk-accent/30 aria-[invalid=true]:border-brk-danger";

/** A one-line control: 40px below md, where its text is 16px (src/index.css,
 *  so iOS never zooms on focus), and 36px from md with the body's 14px, as
 *  the MUI fields are. */
export const FIELD_CONTROL = `h-10 w-full px-3 md:h-9 ${FIELD_BOX}`;

/** A multi-line control (TextAreaField): the box, its height set by `rows`. */
export const FIELD_TEXTAREA = `w-full px-3 py-2 ${FIELD_BOX}`;

/** A read-only value's box (BRK-S349): the control's size and radius with a
 *  grey fill and no focus ring, so a value that can't be edited reads as the
 *  field that holds it. It grows with a long value rather than cutting it off. */
export const FIELD_READONLY =
  "flex min-h-10 w-full min-w-0 items-center gap-1.5 rounded-md border border-brk-border bg-brk-bg px-3 py-2 text-brk-text md:min-h-9";

/** Helper text under a field, in caption. */
export const FIELD_HELP = "text-caption text-brk-dim";

/** A field's error, in caption. */
export const FIELD_ERROR = "text-caption text-brk-danger";

/** A searchable select's option (BRK-S314): a 44px row under a coarse
 *  pointer, the highlighted one filled (MUI marks it `Mui-focused`) and the
 *  chosen one in the accent. */
export const FIELD_OPTION =
  "flex w-full cursor-pointer flex-col items-start justify-center px-3 py-2 text-left text-sm text-brk-text [&.Mui-focused]:bg-brk-bg aria-selected:font-medium aria-selected:text-brk-accent [@media(pointer:coarse)]:min-h-11";
